import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function CtaBanner() {
  return (
    <section className="relative bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative overflow-hidden rounded-2xl bg-foreground-950 text-background-50">
          <div className="absolute inset-0 opacity-25">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20navy%20industrial%20engineering%20scene%20with%20black%20rubber%20parts%20and%20metal%20molds%20arranged%20on%20engineering%20blueprint%2C%20dramatic%20side%20lighting%2C%20premium%20B2B%20manufacturing%20visual%2C%20deep%20shadows%2C%20editorial%20product%20photography%2C%20wide%20panoramic%20composition&width=1800&height=900&seq=krubber-cta-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-center"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950 via-foreground-950/85 to-foreground-950/40" />

          <div className="relative px-7 md:px-14 py-16 md:py-20 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse" />
                <span className="text-[11px] tracking-[0.22em] uppercase text-background-50/85 font-semibold">
                  Solution Inquiry
                </span>
              </div>
              <h2 className="mt-6 font-heading font-extrabold text-3xl md:text-[44px] leading-[1.15] tracking-tight">
                고무제품 때문에<br />
                <span className="text-accent-300">고민하고 계신가요?</span>
              </h2>
              <p className="mt-5 text-base md:text-lg text-background-50/80 leading-relaxed max-w-2xl">
                도면이 없어도 괜찮습니다. 사진 한 장, 샘플 하나만 보내주시면<br className="hidden md:block" />
                저희 엔지니어가 함께 분석하고 해결책을 찾아드립니다.
              </p>

              <div className="mt-10 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  문의하기
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
                <a
                  href={siteInfo.telLink}
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-background-50/30 text-background-50 hover:bg-background-50/10 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
                >
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-phone-line" />
                  </span>
                  TEL · {siteInfo.tel}
                </a>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="rounded-xl bg-background-50/8 backdrop-blur-md border border-background-50/15 p-6">
                <div className="text-[11px] tracking-[0.2em] uppercase text-background-50/60 font-semibold">
                  Quick Contact
                </div>
                <ul className="mt-4 flex flex-col gap-4">
                  <li className="flex items-start gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                      <i className="ri-phone-fill" />
                    </span>
                    <div className="flex flex-col">
                      <span className="text-[11px] text-background-50/55 uppercase tracking-widest">
                        Phone
                      </span>
                      <a
                        href={siteInfo.telLink}
                        className="text-sm font-semibold text-background-50 hover:text-accent-300 cursor-pointer"
                      >
                        {siteInfo.tel}
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                      <i className="ri-mail-fill" />
                    </span>
                    <div className="flex flex-col">
                      <span className="text-[11px] text-background-50/55 uppercase tracking-widest">
                        Email
                      </span>
                      <a
                        href={siteInfo.emailLink}
                        className="text-sm font-semibold text-background-50 hover:text-accent-300 cursor-pointer break-all"
                      >
                        {siteInfo.email}
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10 text-accent-300">
                      <i className="ri-time-fill" />
                    </span>
                    <div className="flex flex-col">
                      <span className="text-[11px] text-background-50/55 uppercase tracking-widest">
                        Business Hours
                      </span>
                      <span className="text-sm font-semibold text-background-50">
                        평일 09:00 - 18:00
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}